import { ref } from 'vue'
import { db, getDoc, doc } from '@/firebase/config'

const getPost = () => {
  const myData = ref(null)
  const error = ref(null)

  const load = async (id, coll) => {
    try {
      const docRef = doc(db, '/schools/inspire-schools/' + coll, id)
      const docSnap = await getDoc(docRef)

      if (!docSnap.exists) {
        throw Error('We can\'t find what you\'re looking. Make sure it exists')
      }
      myData.value = { ...docSnap.data(), id: docSnap.id }
      // console.log(myData.value)
    } catch (err) {
      error.value = err.message
    }
  }

  return { myData, error, load }
}

export default getPost
